import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RegistrationProcessInfoResponse} from '@services/ma/registration-process';
import {ConfigService} from '@services/infra/config.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationProcessService {
  constructor(
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  getProcesses(q: RegistrationProcessQuery): Observable<RegistrationProcessInfoResponse> {
    const url = `${this.conf.backendUrl}/v1/regproc`;
    let params = new HttpParams();
    if (q.offset) {
      params = params.set('offset', q.offset);
    }
    if (q.limit) {
      params = params.set('limit', q.limit);
    }
    if (q.query) {
      params = params.set('query', q.query);
    }
    if (q.order) {
      params = params.set('order', q.order);
    }
    if (q.direction) {
      params = params.set('direction', q.direction);
    }

    return this.http.get<RegistrationProcessInfoResponse>(url, {params});
  }
}

export class RegistrationProcessQuery {
  constructor(
    public readonly offset: string,
    public readonly limit: string,
    public readonly query?: string,
    public readonly order?: string,
    public readonly direction?: 'Asc' | 'Desc',
  ) {}
}
